export const DELETE_ROW_CONFIRM = 'deleteRowConfirmDialog';

export const WEBHOOKS_BASE_URL = '/settings/integration/webhooks';

export const WEBHOOKS_DELIVERIES_URL = `${WEBHOOKS_BASE_URL}/deliveries`;

export const buildWebhookDeliveriesLink = (webhookName: string): string =>
  `${WEBHOOKS_DELIVERIES_URL}?options=${encodeURIComponent(
    JSON.stringify({ filters: { webhook: ['eq', webhookName] } }),
  )}`;

// Statuses a webhook event can carry; used as the fallback option set for the
// test dialog when a trigger condition matches a whole type/action (no status).
export const WEBHOOK_STATUSES = [
  'started',
  'completed',
  'failed',
  'resumed',
  'resumed (stopping)',
  'stopped',
] as const;

export const PAYLOAD_FORMATS = ['json', 'xml'] as const;
export type PayloadFormat = (typeof PAYLOAD_FORMATS)[number];

// Variables available to a payload template, grouped by scope. Exactly one of the
// type-specific groups is present per delivery. Must stay in sync with the
// backend allow-list (ALLOWED_VARIABLES in backend-shared payload-template.ts) —
// referencing anything outside it fails validation on save.
export const TEMPLATE_VARIABLE_GROUPS = {
  common: ['timestamp', 'user_id', 'test'],
  snapshot: [
    'snapshot.action',
    'snapshot.status',
    'snapshot.requester',
    'snapshot.reason',
    'snapshot.snapshot.id',
    'snapshot.snapshot.name',
    'snapshot.snapshot.cloneId',
    'snapshot.snapshot.file',
  ],
  intentCheck: [
    'intent_check.action',
    'intent_check.status',
    'intent_check.requester',
    'intent_check.reason',
    'intent_check.reportId',
    'intent_check.snapshotId',
  ],
} as const;

// Seed shown in the payload-template editor. Reproduces the current payload for
// both event types (only one context is present per delivery, so each
// `{{#…action}}` gate renders for its type). Kept in sync with the canonical
// `DEFAULT_TEMPLATE` in backend-shared payload-template.ts (which validates and
// renders it); drift is harmless — the backend validates and the worker renders
// whatever is actually saved.
export const DEFAULT_PAYLOAD_TEMPLATE = `{{#snapshot.action}}{
  "type": "snapshot",
  "action": {{{snapshot.action}}},
  "status": {{{snapshot.status}}},
  "requester": {{{snapshot.requester}}},
  "timestamp": {{{timestamp}}}{{#snapshot.reason}},
  "reason": {{{snapshot.reason}}}{{/snapshot.reason}}{{#snapshot.snapshot}},
  "snapshot": {{{snapshot.snapshot}}}{{/snapshot.snapshot}}{{#test}},
  "test": {{{test}}}{{/test}}
}{{/snapshot.action}}{{#intent_check.action}}{
  "type": "intent-verification",
  "action": {{{intent_check.action}}},
  "status": {{{intent_check.status}}},
  "requester": {{{intent_check.requester}}},
  "timestamp": {{{timestamp}}}{{#intent_check.reason}},
  "reason": {{{intent_check.reason}}}{{/intent_check.reason}}{{#intent_check.reportId}},
  "reportId": {{{intent_check.reportId}}}{{/intent_check.reportId}}{{#intent_check.snapshotId}},
  "snapshotId": {{{intent_check.snapshotId}}}{{/intent_check.snapshotId}}{{#test}},
  "test": {{{test}}}{{/test}}
}{{/intent_check.action}}`;
